export default __webpack_public_path__ + "static/media/card-filler.00ab0705.png";